import { useState, useEffect } from "react";
import ProjectTableBaseline from "../components/ProjectTableBaseline";
import DeleteIcon from "@mui/icons-material/Delete";
import { observer } from "mobx-react";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import RestoreIcon from "@mui/icons-material/Restore";
import PreBaseline from "../model/PreBaseline";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { projectPrebaselines } from "../operations/ProjectOperations";
import { useProjectStore } from "../model/ProjectStore";
import { useViewState } from "../model/ViewState";

const fromatDateString = (dateString) => {
  let date = new Date(dateString);
  return (
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "/" +
    ("0" + date.getDate()).slice(-2) +
    "/" +
    date.getFullYear()
  );
};

const generateTableRow = (formatedPreBaseline) => {
  return {
    num: formatedPreBaseline.baselineNumber,
    period: formatedPreBaseline.preBaselinePeriod,
    uId: formatedPreBaseline.unqPreBaslineId,
    time: fromatDateString(formatedPreBaseline.dateEffective),
    isArchived: formatedPreBaseline.isArchive,
  };
};

const ManageBaselineView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const project = useProjectStore();
  const view = useViewState();
  const [archiveStarted, setArchiveStarted] = useState(false);
  const [archiveCompleted, setArchiveCompleted] = useState(false);
  const [loadingPrebaseline, setloadingPrebaseline] = useState(false);

  const sortHeadersCurrent = [
    { id: "move", disablePadding: false, label: "Archive Baseline" },
    { id: "num", disablePadding: true, label: "Baseline No." },
    { id: "period", disablePadding: true, label: "Baseline Period" },
    { id: "time", disablePadding: true, label: "Created On" },
  ];
  const sortHeadersArchive = [
    { id: "move", disablePadding: false, label: "Restore Baseline" },
    { id: "num", disablePadding: true, label: "Baseline No." },
    { id: "period", disablePadding: true, label: "Baseline Period" },
    { id: "time", disablePadding: true, label: "Created On" },
  ];

  useEffect(() => {
    project.checkProjUpdate(project.id, project.currentHash, enqueueSnackbar)
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
        if (error.cause === "opaqueredirect") {
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        }
      });

    if (project.preBaselines === undefined || project.preBaselines === null) {
      project.preBaselines = [];
      projectPrebaselines(
        project,
        setloadingPrebaseline,
        (returedProjPrebaseline) => {
          let preBaselineArr = returedProjPrebaseline.map((preBaseline) => {
            let formatedPreBaseline = PreBaseline.fromJS(preBaseline);
            project.preBaselines.push(formatedPreBaseline);

            return generateTableRow(formatedPreBaseline);
          });
          view.setBaselines(preBaselineArr);
        }
      );
    } else {
      let preBaselineArr = project.preBaselines.map((formatedPreBaseline) => {
        return generateTableRow(formatedPreBaseline);
      });
      view.setBaselines(preBaselineArr);
    }
  }, [enqueueSnackbar, project, view]);

  const updateBaselineArchive = (id, project, resultHandler) => {
    const saveState = project.toJS();
    let getAPI = "/api/project/manageBaselineArchive/" + id;
    if (process.env.NODE_ENV !== "production") {
      getAPI = "http://localhost:7071" + getAPI;
    }
    fetch(getAPI, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(saveState),
    }).then((response) => {
      if (!response.ok) {
        response.text().then((text) => {
          throw Error(response.statusText + ": " + text);
        });
      } else {
        setArchiveCompleted(true);
        response.json().then((result) => resultHandler(result));
      }
    });
  };

  const moveCurrent = (unqId) => {
    setArchiveStarted(true);
    project.preBaselines = [];
    updateBaselineArchive(unqId, project, (returnedProjPrebaseline) => {
      returnedProjPrebaseline.forEach((preBaseline) => {
        let formatedPreBaseline = PreBaseline.fromJS(preBaseline);
        project.preBaselines.push(formatedPreBaseline);
      });
    });

    const tableElement = view.activeBaseline.filter((x) => x.uId === unqId)[0];
    view.archiveBaseline.push(tableElement);
    const newCurrent = view.activeBaseline.filter((x) => x !== tableElement);

    view.activeBaseline = newCurrent;
  };

  const moveArchive = (unqId) => {
    setArchiveStarted(true);
    project.preBaselines = [];
    updateBaselineArchive(unqId, project, (returnedProjPrebaseline) => {
      returnedProjPrebaseline.forEach((preBaseline) => {
        let formatedPreBaseline = PreBaseline.fromJS(preBaseline);
        project.preBaselines.push(formatedPreBaseline);
      });
    });

    const tableElement = view.archiveBaseline.filter((x) => x.uId === unqId)[0];
    view.activeBaseline.push(tableElement);
    const newArchive = view.archiveBaseline.filter((x) => x !== tableElement);

    view.archiveBaseline = newArchive;
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setArchiveStarted(false);
    setArchiveCompleted(false);
    setloadingPrebaseline(false);
  };

  return (
    <div>
      <div style={{ display: "flex", marginLeft: 8 }}>
        <ProjectTableBaseline
          tableName="Active Baselines"
          data={view.activeBaseline}
          sortHeaders={sortHeadersCurrent}
          moveIcon={<DeleteIcon />}
          move={moveCurrent}
        />

        <ProjectTableBaseline
          tableName="Archive Baselines"
          data={view.archiveBaseline}
          sortHeaders={sortHeadersArchive}
          moveIcon={<RestoreIcon />}
          move={moveArchive}
        />

        <Snackbar
          title="Archiving Started"
          open={archiveStarted}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="info"
            sx={{ width: "100%" }}
          >
            Baseline's archive status is being changed...
          </Alert>
        </Snackbar>
        <Snackbar
          title="Archiving Successul"
          open={archiveCompleted}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            sx={{ width: "100%" }}
          >
            Baseline's archive status is successfully updated!
          </Alert>
        </Snackbar>
        <Snackbar
          title="Load PreBaseline Message"
          open={loadingPrebaseline}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="info"
            sx={{ width: "100%" }}
          >
            <div>
              <CircularProgress color="inherit" />
              Please wait while the baseline snapshot is being generated, this
              may take several minutes
            </div>
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default observer(ManageBaselineView);
